import { Box, Skeleton } from '@mui/material';

/**
 * Placeholder matching ExpandableProse height while transcription loads.
 * Slightly taller than a short script so the dialog does not jump when text arrives.
 */
export function VerifyMatchTranscriptionSkeleton() {
  return (
    <Box>
      <Skeleton variant="text" width="100%" height={20} />
      <Skeleton variant="text" width="97%" height={20} />
      <Skeleton variant="text" width="70%" height={20} />
    </Box>
  );
}
